import { useState } from 'react';
import '../../styles/SignInUp.css';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useToast } from '../ToastContext';

function NewPassword() {
    const API_URL = process.env.REACT_APP_API_URL;

    const { showToast } = useToast();

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const [password, setPassword] = useState('');

    const [passwordLength, setPasswordLength] = useState(false);
    const [passwordNumber, setPasswordNumber] = useState(false);
    const [passwordChar, setPasswordChar] = useState(false);
    const [passwordSmallLetter, setPasswordSmallLetter] = useState(false);
    const [passwordBigLetter, setPasswordBigLetter] = useState(false);

    const [passwordAccepted, setPasswordAccepted] = useState();
    const [samePasswords, setSamePasswords] = useState();

    const passwordConditions = (pass) => {
        const isLengthValid = pass.length > 7;
        setPasswordLength(isLengthValid);


        const numbers = /[0-9]/
        const isNoValid = numbers.test(pass);
        setPasswordNumber(isNoValid);

        const chars = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/;
        const isCharValid = chars.test(pass);
        setPasswordChar(isCharValid);

        const smallLetters = /[a-z]/
        const bigLetters = /[A-Z]/

        const isSLetterValid = smallLetters.test(pass);
        setPasswordSmallLetter(isSLetterValid);

        const isBLetterValid = bigLetters.test(pass);
        setPasswordBigLetter(isBLetterValid);

        setPassword(pass);
    }

    const checkPasswords = (pass) => {
        if (passwordLength && passwordNumber && passwordChar && passwordSmallLetter && passwordBigLetter) {
            setPasswordAccepted(true);
        } else {
            setPasswordAccepted(false);
        }

        if (password === pass) {
            setSamePasswords(true);
        } else {
            setSamePasswords(false);
        }
    }


    const handlePasswordReset = async (e) => {
        e.preventDefault();

        if (!token) {
            showToast("Brak prawidłowego tokena weryfikacyjnego w adresie URL.", "error")
            return;
        }

        if (!passwordAccepted) {
            showToast("Hasło nie spełnia wszystkich założeń.", "error")
            return;
        }

        if (!samePasswords) {
            showToast("Hasła nie są identyczne.", "error")
            return;
        }

        try {
            const response = await axios.post(`${API_URL}/users/reset-password`, {
                token: token,
                newPassword: password
            })

            if (response.data) {
                navigate('/zmienione-haslo');
            } else {
                showToast("Wystąpił błąd, spróbuj ponownie.", "error")
            }

        } catch (error) {
            if (error.response) {
                if (error.response.status === 409) {
                    showToast("Użytkownik o takim adresie e-mail już istnieje", "error")
                } else {
                    showToast("Wystąpił błąd, spróbuj ponownie.", "error")
                }
            } else {
                showToast("Błąd połączenia z serwerem", "error");
            }
        }
    }


    return (
        <div className="register-wrapper">
            <div className="register-card">
                <h2 className="register-title">
                    TRADI<span className="logo-highlight">WORLD</span>
                </h2>
                <p className="register-subtitle">Aby zresetować hasło, podaj nowe hasło.</p>

                <form onSubmit={handlePasswordReset} method='POST' className="register-form">
                    <div className="input-group">
                        <label htmlFor="password">Hasło</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            placeholder="••••••••"
                            onChange={(e) => passwordConditions(e.target.value)}
                            required
                        />

                        <p style={{ "color": `${passwordLength ? "green" : "red"}`, "fontSize": "small" }}>Minimum 8 znaków</p>
                        {passwordNumber ? <p style={{ "color": "green", "fontSize": "small" }}>Zawiera liczbę</p> : <p style={{ "color": "red", "fontSize": "small" }}>Zawiera liczbę</p>}
                        {passwordChar ? <p style={{ "color": "green", "fontSize": "small" }}>Zawiera znak specjalny</p> : <p style={{ "color": "red", "fontSize": "small" }}>Zawiera znak specjalny</p>}
                        {passwordSmallLetter && passwordBigLetter ? <p style={{ "color": "green", "fontSize": "small" }}>Zawiera dużą i małą literę</p> : <p style={{ "color": "red", "fontSize": "small" }}>Zawiera dużą i małą literę</p>}
                    </div>

                    <div className="input-group">
                        <label htmlFor="password">Powtórz hasło</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            placeholder="••••••••"
                            onChange={(e) => checkPasswords(e.target.value)}
                            required
                        />
                        {samePasswords ? <></> : <p style={{ "color": "red", "fontSize": "small" }}>Hasła nie są takie same</p>}
                    </div>

                    <button type="submit" className="register-button">
                        Zmień hasło
                    </button>
                </form>
            </div>
        </div>
    );
}

export default NewPassword;